module.exports = __webpack_public_path__ + "img/avatar6.90fdf1ef.png";